import React from "react";
import {getStyle} from "../../services/Style";
import PropTypes from 'prop-types';

export default class ButtonLinkPrimary extends React.PureComponent
{
    static propTypes = {
        positionId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        className: PropTypes.string,
        href: PropTypes.string,
        onclick: PropTypes.func,
        customerName: PropTypes.string.isRequired,
        buttonType: PropTypes.string,
        usePrimary: PropTypes.bool
    };

    static defaultProps = {
        usePrimary: true
    };

    constructor(props)
    {
        super(props);
		let buttonStyle = getStyle(this.props.positionId, this.props.buttonType, this.props.customerName);
		let buttonHoverStyle = getStyle(this.props.positionId, this.props.buttonType + '-hover', this.props.customerName);
		if (this.props.usePrimary) {
			buttonStyle = Object.entries(buttonStyle).length === 0 ? getStyle(this.props.positionId, 'primary-button', this.props.customerName) : buttonStyle;
			buttonHoverStyle = Object.entries(buttonHoverStyle).length === 0 ? getStyle(this.props.positionId, 'primary-button-hover', this.props.customerName) : buttonHoverStyle;
		}
		buttonHoverStyle = Object.entries(buttonHoverStyle).length === 0 ? buttonStyle : buttonHoverStyle;
		this.state = {
			button: buttonStyle,
			buttonStyle: buttonStyle,
			buttonHoverStyle: buttonHoverStyle
		};
    }

    changeToHoverStyle = (hover) => {
        this.setState({
            button : hover ? this.state['buttonHoverStyle'] : this.state['buttonStyle']
        });
    };

    render() {
        return (
            <a
                href={this.props.href}
                onClick={this.props.onClick}
                className={this.props.className}
                style={this.state['button']}
                onMouseEnter ={() => this.changeToHoverStyle(true)}
                onMouseLeave ={() => this.changeToHoverStyle(false)}
            >
                {this.props.children}
            </a>
        );
    }
}
